import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { DashboardSidebar } from '../DashboardSidebar';
import { DashboardContainer } from './styles';
import { useSidebar } from '../../contexts/SidebarContext/hook';
import { CasesProvider } from '@frontend/features/cases/components/CaseContext';
import { WhatsappClientProvider } from '@frontend/features/whatsapp/components/WhatsappClientContext';

// FIXME: remove children prop
interface DashboardLayoutProps {
  children?: JSX.Element;
}

export const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const { isOpen } = useSidebar();

  return (
    <WhatsappClientProvider>
      <CasesProvider>
        <Box bgcolor="paper.dark" minHeight="100vh" display="flex" flexDirection="column" alignItems="flex-end">
          <DashboardSidebar />
          <DashboardContainer isSidebarOpen={isOpen}>{children || <Outlet />}</DashboardContainer>
        </Box>
      </CasesProvider>
    </WhatsappClientProvider>
  );
};
